import styled from 'styled-components'

const VerticalHr = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors['neutral-color-10']};
  margin: 0 16px;
`
export default VerticalHr
